import { useContext, useEffect } from 'react';
import { SiteContext } from '../../../context/SiteContext';
import RadioOptions from '../../common/RadioOptions/RadioOptions';
import { DefaultRadioOptions, PageAbsolutePath } from '../../../consts/Common';
import { ButtonContinue } from '../../common/Button/ButtonContinue';
import { setCountryCode } from '../../common/HelperMethods';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { InsuranceJourneyContext } from '../../common/CommonTypes';
import { ButtonBack } from '../../common/Button/ButtonBack';
import InsuranceDocumentLink from './InsuranceDocumentLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

const ImportantNoticeInformationPage = (): JSX.Element => {
  const pdfIcon = <FontAwesomeIcon icon={faFilePdf} className='m1-right' />;
  const { site } = useContext(SiteContext);
  const navigate = useNavigate();
  const { journey, pageEvents } = useOutletContext<InsuranceJourneyContext>();
  const { importantNoticeInformationDetails, insuranceProducts } = journey;
  const { readAndUnderstoodImportantInformationNotice } =
    importantNoticeInformationDetails;
  const { importantNoticeInformationDetailsPage, commonEvents } = pageEvents;
  const { onChangeReadAndUnderstoodImportantInformationNotice } =
    importantNoticeInformationDetailsPage;
  const { onPageChange } = commonEvents;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onBackClick = () => {
    const path: string = setCountryCode(
      PageAbsolutePath.Insurance.AboutTermsOfBusinessAndFairUsageNotice,
      site.countryCode
    );
    navigate(path);
    onPageChange(PageAbsolutePath.Insurance.YourQuote, true);
  };

  const onNextClick = () => {
    const path: string = setCountryCode(
      PageAbsolutePath.Insurance.SettingUpDirectDebit,
      site.countryCode
    );
    navigate(path);
    onPageChange(PageAbsolutePath.Insurance.YourQuote, true);
  };

  return (
    <div className='no-stepper'>
      <h5 className='section-header m3-top'>
        Paying monthly: Important Information Notice
      </h5>

      <h6 className='section-header m3-top'>
        <b>Please read carefully:</b>
      </h6>
      <p>
        {site.brand.brandDisplayFullName} Insurance is a trading name of Car
        Care Plan Ltd. We are a credit broker that arranges premium finance on
        behalf of our customers. We do not act as a finance lender. Details of
        the lender will be shown in your documentation.
      </p>

      <p>
        For more information, please call our customer service team on{' '}
        {site.brand.brandPhoneNumbers.quotesAndRenewalsNumber}.
      </p>

      <p>
        These documents will open in a new pop-up window. You must view the
        documents before proceeding. If they are not opening, you may have
        pop-ups blocked on your device and will need to adjust your settings to
        allow this. If you need any help, please contact us.
      </p>
      <InsuranceDocumentLink
        displayText={'Download important information notice'}
        documentId={insuranceProducts.importantInformationNoticeDocumentId}
        icon={pdfIcon}
      />
      <div className='one-col'>
        <div className='max-content'>
          <RadioOptions
            errorMessage=''
            selectedOption={
              readAndUnderstoodImportantInformationNotice === null
                ? ''
                : readAndUnderstoodImportantInformationNotice
                  ? 'Yes'
                  : 'No'
            }
            optionsList={DefaultRadioOptions}
            setSelectedOption={(value) =>
              onChangeReadAndUnderstoodImportantInformationNotice(
                value === 'Yes'
              )
            }
            label={
              'I have read and understood this Important Information Notice.'
            }
            name='readAndUnderstoodImportantInformationNotice'
          />
        </div>
      </div>
      <div className='one-col'>
        <p className='info-message'>
          You have chosen to pay for your insurance <b>monthly</b> via premium
          finance, you will incur additional fees and interest which will result
          in you paying a higher amount.
        </p>
      </div>
      <div className='flex-row form-nav'>
        <ButtonBack
          name='btn-back'
          text='Back'
          onClick={onBackClick}
          additionalClassNames='btn-back'
        />
        {readAndUnderstoodImportantInformationNotice && (
          <ButtonContinue
            name={'btn-Next'}
            text={'Next'}
            onClick={onNextClick}
            additionalClassNames='btn-continue'
          />
        )}
      </div>
    </div>
  );
};

export default ImportantNoticeInformationPage;
